import { render } from "./Signpad.vue?vue&type=template&id=704c01a1&scoped=true"
import script from "./Signpad.vue?vue&type=script&lang=js"
export * from "./Signpad.vue?vue&type=script&lang=js"

import "./Signpad.vue?vue&type=style&index=0&id=704c01a1&scoped=true&lang=scss"

import exportComponent from "D:\\Source\\mobaxe\\mobaxe.docs.app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704c01a1"]])

export default __exports__